import { render, staticRenderFns } from "./CardCertifiedList.vue?vue&type=template&id=4bb40ebd"
import script from "./CardCertifiedList.vue?vue&type=script&lang=js"
export * from "./CardCertifiedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports